'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultDate = getDefaultDate;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

function getDefaultDate(date) {
  var returnDate = void 0;
  if (date) {
    var defaultDate = (0, _momentTimezone2.default)().startOf('day').add(1, 'days').toDate();
    if ((0, _momentTimezone2.default)(date).isBefore((0, _momentTimezone2.default)(defaultDate), 'day')) {
      returnDate = defaultDate;
    } else {
      returnDate = date;
    }
  }
  return returnDate;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/session.js
// module id = 1709
// module chunks = 47